import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/orders/_layout/')({
  component: () => null,
});
